module.exports = __webpack_public_path__ + "img/design_qgourmetcafe.1cc1231c.jpg";